import { sensorTotalConsumptionConstants } from "../../constants/client";

export const sensorTotalConsumption = {
  totalConsumption,
  totalConsumptionSuccess,
  totalConsumptionFailure,
};

function totalConsumption(payload) {
  return { type: sensorTotalConsumptionConstants.TOTAL_CONSUMPTION_REQUEST,  payload };
}

function totalConsumptionSuccess(payload) {
  return { type: sensorTotalConsumptionConstants.TOTAL_CONSUMPTION_SUCCESS, payload };
}

function totalConsumptionFailure(error) {
  return { type: sensorTotalConsumptionConstants.TOTAL_CONSUMPTION_FAILURE, error };
}